import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import { ClassAttributes, createElement, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';

type Props = ClassAttributes<HTMLElement> & {
  onClickInquiryButton: MouseEventHandler<HTMLElement>;
  className?: string;
};

const NoResult = ({ onClickInquiryButton, className }: Props) => (
  <Root className={className}>
    <Heading variant="h6" color="textSecondary">
      <FormattedMessage id="project_types_list_page.no_result.heading" />
    </Heading>
    <Description color="textSecondary">
      <FormattedMessage
        id="project_types_list_page.no_result.description.text"
        values={{
          button: (
            <InquiryButton onClick={onClickInquiryButton}>
              <FormattedMessage id="project_types_list_page.no_result.description.button" />
            </InquiryButton>
          ),
        }}
      />
    </Description>
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto', 'auto'],
    areas: [['heading'], ['description']],
    alignContent: 'center',
    justifyItems: 'center',
  }),
);

const Heading = styled(Typography)({
  ...gridLayoutItem('heading'),
  marginBottom: SPACING_UNIT * 2,
});

const Description = styled(Typography)(gridLayoutItem('description'));

const InquiryButton = styled(Button)({ display: 'inline' });

export default NoResult;
